export const LABEL_FOLDER_KEY = "folder:";
export const AUTO_ATTACHMENT_KEY = "autoattach:";
export const AUTO_ATTACHMENT_READ_KEY = "autoattach_read:";
export const AUTO_ATTACHMENT_WRITE_KEY = "autoattach_write:";
